<template>
  <main class="html-page home-page articles-page">
<main class="soro-content"><div class="container"><div id="soro-blog"></div></div></main>
    
      <a class="whatsapp" href="https://wa.me/5551991544590" aria-label="Falar pelo WhatsApp"><span></span></a>
    
  </main>
</template>

<script>
export default {
  name: 'ArtigosView',
  mounted() {
    document.title = "Artigos | Imaginar";
    this.loadSoro();
  },
  beforeUnmount() {
    const script = document.getElementById('soro-embed-script');
    if (script) script.remove();
  },
  methods: {
    loadSoro() {
      const container = this.$el.querySelector('#soro-blog');
      if (!container) return;

      const previousScript = document.getElementById('soro-embed-script');
      if (previousScript) previousScript.remove();
      container.innerHTML = '';

      const script = document.createElement('script');
      script.id = 'soro-embed-script';
      script.src = 'https://app.trysoro.com/api/embed/64001b92-6af2-46d6-bc8c-05184a52f917';
      script.defer = true;
      document.body.appendChild(script);
    },
  },
};
</script>
